export const accounts = [
  {
    "key": "linkedin",
    "name": "LinkedIn",
    "url": "https://www.linkedin.com/company/comms-dealer/",
    "icon": ''
  }
]